module.exports = __webpack_public_path__ + "img/Verduisterend.7695dee1.png";